function toastReducer(state, action) {
    switch (action.type) {
        case 'addToast': {
            return {
                ...state,
                toasts: [...state.toasts, action.payload.toast],
            };
        }

        case 'updateToast': {
            return {
                ...state,
                toasts: [...state.toasts.map(toast => toast.id == action.payload.id ? action.payload : toast)],
            };
        }

        case 'deleteToast': {
            return {
                ...state,
                toasts: [...state.toasts.filter((toast) => toast.id != action.payload.id)],
            };
        }
        default: {
            throw new Error('unhandled action');
        }
    }
}

export default toastReducer;